import React, { FC } from 'react'

import { getChartAttr } from 'shared/utils/chartConfig'
import { formatDate } from 'shared/utils/formatDate'

import { KPIPopoverProps } from './KPIPopover.props'
import './KPIPopover.scss'

const KPIPopover: FC<KPIPopoverProps> = ({ source, fact, reachedPeakAt, countryCode, hideTitle }) => {
  const chartName = getChartAttr(source.chart)?.name
  return (
    <div className="kpi">
      {!hideTitle && <b className="kpi__title">{chartName}</b>}
      <ul className="kpi-list">
        <li className="kpi-list__item">
          <b>Chart:</b>&nbsp;{chartName}&nbsp;{`${source?.limit || ''}`}&nbsp;{countryCode}
        </li>
        <li className="kpi-list__item">
          <b>Current position:</b>&nbsp;{fact?.position_current || '--'}
        </li>
        <li className="kpi-list__item">
          <b>Current updated at:</b>&nbsp;{fact?.position_current_at && formatDate({ date: fact.position_current_at })}
        </li>
        <li className="kpi-list__item">
          <b>Previous position:</b>&nbsp;{fact?.position_last}
        </li>
        <li className="kpi-list__item">
          <b>Peak position:</b>&nbsp;{fact?.peak}
        </li>
        <li className="kpi-list__item">
          <b>Peak reached at:</b>&nbsp;{reachedPeakAt && formatDate({ date: reachedPeakAt })}
        </li>
        <li className="kpi-list__item">
          <b>Frequency:</b>&nbsp;
          {source.release_info}
        </li>
      </ul>
    </div>
  )
}

export default KPIPopover
